import {
  toId as storybookToId,
  storyNameFromExport as storybookStoryNameFromExport,
  isExportStory as storybookIsExportStory,
} from "@storybook/csf";

export const toId: typeof storybookToId = (...args) => storybookToId(...args);
export const storyNameFromExport: typeof storybookStoryNameFromExport = (...args) =>
  storybookStoryNameFromExport(...args);
export const isExportStory: typeof storybookIsExportStory = (...args) =>
  storybookIsExportStory(...args);
